export default {
  route: {
    App_Type_Design: 'App Type Design',
    App_Manage: 'App Manage',
    Flow_List: 'Flow List',
    Form_Type_Design: 'Form Type Design',
    companyName: 'Company Name',
    auth_character: 'Auth&Character',
    auth: 'Auth',
    character_type: 'Character Type',
    character: 'Character',
    codeList: 'Code List',
    log_manage: 'Log Manage',
    opt_log: 'Operate Log',
    search_log: 'Search Log',
    menu_manage: 'Menu Manage',
    source_manage: 'Source Manage',
    org_people: 'Org&People',
    org_str: 'Org Stc',
    people_manage: 'People Manage',
    work_bench: 'Work Bench',
    config: 'Config',
    password: 'Password Strength',
    company_manage: 'Company Manage',
    annex_manage: 'Annex Manage',
    company_index:"Company Index Info",
    company_detail_info:"Company Detail Info",
    basic_info:"Basic Info",
    people_info:'People Info',
    org_human_demo: 'Organization Personnel Demo',
    people_basic_info: 'Staff Basic Information',
    process_management:'Process Manage',
    process_type_management:'Process Type Manage',
    process_list_management:'Process List Manage',
    process_template:'process_templat',
    process_template_type:'process_templat_type'
  },
  login: {
    title: 'Login Form',
    logIn: 'Log in',
    username: 'Username',
    password: 'Password',
    any: 'any',
    thirdparty: 'Or connect with',
    thirdpartyTips: 'Local can not be simulated, please combine their own business simulation! ! !'
  },
  button: {
    confirm: 'Confirm',
    cancel: 'Cancel',
    edit: 'Edit',
    add: 'Add',
    search: 'search',
    delete: 'Delete',
    deleteSelected: 'Del Selected',
    code: 'code',
    distribution: 'Distribution',
    detail: 'Detail',
    enable: 'Enable',
    disable: 'Disable',
    save: 'Save',
    search_child:'Search All Children Org?',
    move: 'Move'
  },
  table: {
    fatherType: 'Father Type',
    typeName: 'Type Name',
    typeId: 'Type ID',
    formTypeName: 'Form Type Name',
    opt: 'operate',
    appName: 'App Name',
    appId: 'App Id',
    fatherApp: 'Father App',
    des: 'Description',
    status: 'Status',
    name: 'Name'

  },
  title: {
    title: 'SeDin Corporation',
    please_select_node: 'Please Select Left Tree Node First'
  },
  org:{
    org_name: 'Org Name',
    org_id: 'Org Id',
    father_id: 'Father Id',
    index: 'Index',
    org_short: 'Abbreviation',
    org_type: 'Org Type',
    group_company: 'Group Corporation',
    child: 'Child Company',
    org: 'Organization',
    virtual: 'Virtual Dir',
    org_basic: 'Org Basic Info',
    org_extend: 'Org Extend Info',
    org_account:'Org Account Info',
    room_number: 'Room Number',
    fax: 'Fax',
    postal_address: 'Postal Address',
    tel: 'Tel Number',
    company_name: 'Company Name',
    tax: 'Tax No.',
    deposit_bank: 'Bank Of Deposite',
    account: 'Bank Account',
    company_address: 'Company Address',
    allowed_invoice: 'Allowed Invoice',
    prefer_invoice: 'Prefered Invoice',
    vat_special_invoice: 'VAT special invoice',
    vat_normal_invoice: 'VAT normal invoice',
    platform: 'Platform Org Str',
    xz:'Department Org Str'
  },
  people:{
    name: 'Name',
    sex: 'Sex',
    mobile: 'Mobile',
    position: 'Position',
    select_org:'Select Organiztion',
    select_people:'Select People',
    account_info: 'Account Info',
    base_info: 'Base Info',
    account: 'Account',
    password: 'Password',
    checktype: "Validate Type",
    keyinfo: "Key Info",
    account_type: "Account Type",
    account_expire: "Expire",
    status: 'Status',
    uuid: 'UUID',
    en_name: "English Name",
    cn_name: "Chinese Name",
    birthday: "Birthday",
    email: "Email",
    ID: "ID",
    character: 'Character',
    avatar: 'Avatar',
    default_password:'Default:123456',
    on_position:'Employeed',
    off_position:'Fired',
    male:'Male',
    female:'female'
  },
  company: {
    title: 'The enterprise management',
    enterprisenum: 'Enterprise',
    corporatelogo: 'Corporate Logo',
    enterprisename: 'An enterprise name',
    enterprisejc: 'The enterprise referred to as',
    enterprisetel: 'Business phone',
    text1: 'File will drag here, or',
    text2: 'Click on the upload',
    tip1: 'Supports JPG, jpeg, PNG, BMP format',
    tip2: 'Picture is less than 5 m (80 * 80 pixels), more than the size will be compressed and lower quality',
    tip3: 'Word count limit 30 characters',
    tip4: 'Note: the system on display'
  },
  menu: {
    xuhao: 'NO.',
    menuID: 'MenuID',
    fatherMenu: 'Father Menu',
    menuName: 'Menu Name',
    fatherApp: 'Father App',
    menuAddrType: 'Menu Address Type',
    openMode: 'Open Mode',
    selMenuAddrType: 'Select Menu Address Type',
    systemAddr: 'System Address',
    innerAddr: 'Inner Address',
    outerAddr: 'Outer Address',
    formAddr: 'Form Address',
    menuAddr: 'Menu Address',
    menuAuth: 'Menu Authority',
    sourceCode: 'Source Code',
    authCode: 'Authority Code',
    formAuth: 'From Authority',
    yes: 'Yes',
    no: 'No',
    chooseOpenMode: 'Choose Open Mode',
    default: 'Default',
    newPage: 'New Page',
    assignPosition: 'Assign Position',
    moveMenu: 'Move Menu',
    addMenu: 'Add menu',
    editMenu: 'Edit Menu',
    move: 'Move'
  },
  log: {
    startDate: 'Start Date',
    endDate: 'End Date',
    to: 'To',
    logDate: 'Log Date',
    userName: 'User Name',
    userIP: 'User IP',
    optContent: 'Operation Content',
    optNodeID: 'Operation Node ID',
    optNodeIP: 'Operation Node IP',
    compData: 'Complete Data',
    optType: 'Operation Type'
  },
  source: {
    sourceCode: 'Source Code',
    sourceDesc: 'Source Describe',
    sourceAddr: 'Source Address',
    needAuth: 'Need Permission Authentication',
    needLogin: 'Need Login'
  },
  code: {
    xuhao: 'No.',
    codeTypeID: 'Code Type ID',
    codeTypeName: 'Code Type Name',
    codeTypeClassify: 'Code Type Classify',
    codeStandard: 'Follow Standard',
    codeTypeDescribe: 'Code Type Describe',
    opt: 'Operate',
    codeManage: 'Code Manage',
    codeState: 'State',
    codeName: 'Code Name',
    codeValue: 'Code Value',
    supCode: 'Superior Code',
    codeSubname: 'Subname',
    codeShortName: 'Short Name',
    codeAbbreviations: 'Abbreviations Code',
    codeFullSpell: 'Full Spell Code',
    codeExpand: 'Expand Code'
  },
  auth: {
    permissionName: 'Permission to name',
    permissionID: 'Authorization ID',
    allocationOfresources: 'Allocation of resources',
    newpermissionInfo: 'Name of new permissions',
    accesscode: 'Access code',
    higherauthority: 'The higher authority',
    permissioninfo: 'Permission information',
    resourceid: 'Resource ID',
    resourcename: 'The name of the resource'
  },
  character: {
    characterName: 'Character name',
    characterType: 'The role type',
    characterID: 'Character ID',
    characterstate: 'Character state',
    belonger: 'Organisation',
    checkTheStaff: 'Check the staff',
    assignpermissions: 'Assign permissions',
    assignfrompermissions: 'Distribution form permissions',
    personlist: 'Personnel list',
    roleinfo: 'The role of information',
    select: 'Please select ',
    staffname: 'Staff name',
    staffid: 'StaffID',
    belongerbumen: 'Subordinate departments',
    formname: 'Form name',
    formid: 'Form ID',
    toview: 'To view',
    modify: 'Modify ',
    increase: 'Increase',
    delete: 'Delete'
  },
  character_type: {
    character_typeName: 'The role type name',
    character_typeID: 'Role type ID',
    character_typeinfo: 'The role type information',
    character_types: 'Role type classification',
    keywords: 'Keywords'
  }
}
